import React from 'react';
import { Tag } from 'antd';
import moment from 'moment';
import numeral from 'numeral';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routes, subRoutes } from '../../utils/constants/routes';

const useColumns = () => {
  const { t } = useTranslation();

  return [
    {
      title: t('contracts.column.quoteNumber'),
      dataIndex: 'quote_number',
      width: 150,
      key: 'quote_number',
      render: (number, record) => (
        <Link
          style={{ fontWeight: 'bold' }}
          to={`${routes.QUOTES}${subRoutes.QUOTES.QUOTES_SAVED}/show/${record.key}`}
        >
          {number}
        </Link>
      ),
      sorter: true
    },
    {
      title: t('contracts.column.created_at'),
      dataIndex: 'created_at',
      key: 'created_at',
      width: 100,
      render: (date) => date && moment(date).format('DD/MM/YYYY H:MM'),
      ellipsis: true,
      sorter: (a, b) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
      defaultSortOrder: 'descend'
    },
    {
      title: t('contracts.column.company_name'),
      dataIndex: 'customer',
      key: 'customer.company_name',
      width: 120,
      render: (customer, { key }) =>
        customer && (
          <Link
            style={{ fontWeight: 'bold' }}
            to={`${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CLIENTS}/show/${key}`}
          >
            {customer.company_name || 'N/A'}
          </Link>
        ),
      sorter: true,
      ellipsis: true
    },
    {
      title: t('contracts.column.type'),
      dataIndex: 'type',
      key: 'type',
      width: 80,
      render: (type) => type,
      sorter: true,
      ellipsis: true
    },
    {
      title: t('contracts.column.client'),
      dataIndex: 'customer',
      key: 'customer',
      width: 110,
      render: (customer, { key }) =>
        customer && (
          <Link
            style={{ fontWeight: 'bold' }}
            to={`${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CLIENTS}/show/${key}`}
          >
            {`${customer.first_name} ${customer.last_name}`}
          </Link>
        ),
      sorter: true,
      ellipsis: true
    },
    {
      title: t('contracts.column.total_monthly'),
      align: 'right',
      render: (contract) =>
        `${numeral(contract.total_monthly_customer).format('0,0.00')}€`,
      key: 'total_monthly_customer',
      sorter: true,
      width: 80
    },
    {
      title: t('contracts.column.fraction_type'),
      dataIndex: 'fraction_type',
      key: 'fraction_type',
      width: 130,
      render: (fraction_type) => (
        <Tag>{t(`contracts.form.options.${fraction_type}`)}</Tag>
      ),
      sorter: true
    },
    {
      title: t('contracts.column.commission_fee_year'),
      align: 'right',
      width: 150,
      render: (remuneration) =>
        `${numeral(remuneration * 12).format('0,0.00')} €`,
      dataIndex: 'remuneration',
      key: 'remuneration',
      sorter: true
    },
    {
      title: t('contracts.column.paperwork_fee'),
      dataIndex: 'paperwork_fee',
      align: 'right',
      width: 150,
      render: (n) => `${numeral(n).format('0,0.00')}€`,
      key: 'paperwork_fee',
      sorter: true
    },
    {
      title: t('contracts.column.commission_fee'),
      align: 'right',
      width: 130,
      render: ({ commission_fee, remuneration }) =>
        `${commission_fee || 0}% (soit ${numeral(remuneration).format(
          '0,0.00'
        )} €)`,
      key: 'commission_fee',
      sorter: true
    },
    {
      title: t('contracts.column.insurer'),
      dataIndex: 'insurer',
      key: 'insurer',
      width: 140,
      render: (insurer) => insurer?.name || 'N/A',
      sorter: true
    }
  ];
};

export default useColumns;
